import React from 'react';
import { useBrand } from '../../../app/config/brand';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  padding?: boolean;
}

export const Card: React.FC<CardProps> = ({ children, className = '', padding = true }) => {
  const brand = useBrand();
  return (
    <div
      className={`rounded-xl shadow-xs ${padding ? 'p-6' : ''} ${className}`}
      style={{ backgroundColor: brand.colors.bgCard, border: `1px solid ${brand.colors.border}` }}
    >
      {children}
    </div>
  );
};
